import * as ACTIONS from "../actions";

import Api from "../../services";
//import { isNull } from "util";
import cm from "./CommonFunction";

const CommissionsModule = {
  state: {
    CommissionsLoading: false,
    CommissionsError: null,
    COMMITION: [],
    COMMITIONSAVELOADING: false,
    COMMITIONSAVEERROR: null,

    //BANK: []
  },
  getters: {
    COMMITIONLOADING: (state) => state.CommissionsLoading,
    COMMITIONERROR: (state) => state.CommissionsError,
    GETCOMMITION: (state) => state.COMMITION,
    GETCOMMITIONSAVELOADING: (state) => state.COMMITIONSAVELOADING,
    GETCOMMITIONSAVEERROR: (state) => state.COMMITIONSAVEERROR,
    //GETCOMMITIONBANKS: state => state.BANK
  },
  actions: {
    [ACTIONS.COMMISSIONS_GET]: (context, url) => {
      // var { commit } = context;

      context.commit(ACTIONS.COMMISSIONS_GET_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Commission/GetCommission" + url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.COMMISSIONS_GET_SUCCESS,
              ACTIONS.COMMISSIONS_GET_ERROR,
              true,
            );

            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.COMMISSIONS_GET_ERROR);
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.COMMISSIONS_GET_PENDING]: (state) => {
      state.CommissionsError = null;
      state.CommissionsLoading = true;
    },
    [ACTIONS.COMMISSIONS_GET_SUCCESS]: (state, data) => {
      state.CommissionsError = null;
      state.CommissionsLoading = false;
      state.COMMITION = data.commission;
      //state.BANK = data.bank;
    },
    [ACTIONS.COMMISSIONS_GET_ERROR]: (state, msg) => {
      state.CommissionsError = msg;
      state.CommissionsLoading = false;
    },

    [ACTIONS.COMMOTION_SAVE_PENDING]: (state) => {
      state.COMMITIONSAVEERROR = null;
      state.COMMITIONSAVELOADING = true;
    },
    [ACTIONS.COMMOTION_SAVE_SUCCESS]: (state) => {
      state.COMMITIONSAVEERROR = null;
      state.COMMITIONSAVELOADING = false;
    },
    [ACTIONS.COMMOTION_SAVE_ERROR]: (state, msg) => {
      state.COMMITIONSAVEERROR = msg;
      state.COMMITIONSAVELOADING = msg;
    },
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      } else {
        commit(SuccessAction);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 2 ||
        data.StatusCode == 429 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};
export default CommissionsModule;
